<h2>Select add ons</h2>

<div class="flex justify-content-center">
  <div class="flex flex-column gap-1">
    @for (item of items(); track item.SkuPk) {
    <div class="flex flex-row flex-wrap spacer gap-3">
      <div class="flex align-items-center justify-content-center input">
        <p-inputNumber [showButtons]="true"
                       [min]="0"
                       [(ngModel)]="item.cartQty"
                       buttonLayout="horizontal"
                       inputId="horizontal"
                       spinnerMode="horizontal"
                       incrementButtonIcon="pi pi-plus"
                       decrementButtonIcon="pi pi-minus" />
      </div>
      <div class="flex align-items-center justify-content-center">
        {{item.Description}} ({{item.Price === 0 ? 'No Charge' : item.Price | currency}})
      </div>
    </div>
    }
  </div>
</div>
@if (isLoading()) {
<div class="progress-spinner">
  <p-progressSpinner></p-progressSpinner>
</div>
}
<div class="flex justify-content-between mt-1 w-full">
  <p-button [routerLink]="['../', routes.TERMS]" label="BACK"></p-button>
  <p-button (click)="onNextClick()" label="NEXT"></p-button>
</div>